module.exports = __webpack_public_path__ + "img/montesquieu.964b21fc.jpg";